/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Apps/Content/App/ConnectionAction/Install/Content",
  onChange,
  disabled
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let constantData = 'Install'
let appNameValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'name',
})
let constantData1 = 'app'
let aggregateData = fromAggregate.join(constantData, appNameValueData, constantData1)
let appAcceptedTermsAndConditionsValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'acceptedTermsAndConditions',
})
let appAcceptedTermsAndConditionsChangeData = fromData.useDataChange({ viewPath,
context: 'app',
path: 'acceptedTermsAndConditions',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onChange,
  disabled
  
})
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 data="'Install'"
 data="app.name"
 data="'app'"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxWithInputText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 marginTop={0.1}
 text="I understand that by granting a third party access to Greyfinch Connect, I am allowing them to access my data within the Greyfinch Platform, which may include HIPAA-protected, sensitive, or private information. I acknowledge that I am responsible for how this access is used. I certify that I am authorized to grant this access and share this information. I have read and agree to the terms and conditions outlined in the Master Services Agreement, available at:"
 data="app.acceptedTermsAndConditions"
 onChange={appAcceptedTermsAndConditionsChangeData}
 value={appAcceptedTermsAndConditionsValueData}
/>
<TysiaTextLink
{...childProps}
  viewPath={`${viewPath}/TysiaTextLink`}
 marginLeft={26}
 text="greyfinch.com/master-services-agreement"
 goTo="https://greyfinch.com/master-services-agreement"
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<TysiaModalFooterAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../No'))}
 type="secondary"
 text="Cancel"
/>
<TysiaModalFooterAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 onClick={onClick}
 disabled={disabled}
 type="primary"
 text="Install"
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}